import React, { useState } from "react";
import "./Sickle.css";

export const Sickle = ({ onSaveTest, SickleNextLoading, setDiseaseType, setTestType, onClose }) => {
  const [isNextStep, setIsNextStep] = useState(false);
  const [radioDiseaseType, setRadioDiseaseType] = useState(3);
  const [radioTestType, setRadioTestType] = useState(0);

  const handleDiseaseTypeChange = (event) => {
    setIsNextStep(false);
    setRadioTestType(0);
    setDiseaseType(event.target.value);
    setRadioDiseaseType(event.target.value);
    if(event.target.value == 3){
      setTestType(2);
      setRadioTestType(2);
      setIsNextStep(true);
    }
    
  };

  const handleTestTypeChange = (event) => {
    setTestType(event.target.value);
    setRadioTestType(event.target.value);
    setIsNextStep(true);
  }

  const handleSave = () => {
    onSaveTest();
  };

  return (
    <>

            <div className="modal fade show d-block verificationModel" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ background: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header border-bottom-0 ">
                            <div className="text-center headerText">
                                <h5 className="modal-title" id="exampleModalLabel">Sickle Cell</h5>
                            </div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClose} /> {/* onClick={onClose} */}
                        </div>
                        <div className="modal-body">
                            <div className="Sickle-master">
                              {localStorage.getItem("sickle_refresh_token") ?
                                <>
                                  <p>Test for Disease Type</p>
                                  <div className="row">
                                    <div className="col-md-4">
                                      <div className="radio-group">
                                        <input
                                          type="radio"
                                          name="diseaseType"
                                          value="1"
                                          onChange={handleDiseaseTypeChange}
                                        />
                                        <span>Sickle</span>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="radio-group">
                                        <input
                                          type="radio"
                                          name="diseaseType"
                                          value="2"
                                          onChange={handleDiseaseTypeChange}
                                        />
                                        <span>Thalassemia</span>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="radio-group">
                                        <input
                                          type="radio"
                                          name="diseaseType"
                                          value="3"
                                          onChange={handleDiseaseTypeChange}
                                        />
                                        <span>Other Variant</span>
                                      </div>
                                    </div>
                                  </div>
                                  <p>Test Type</p>
                                  <div className="row">
                                    <div className="col-md-3">
                                      <div className={`radio-group ${radioTestType == 1 ? "radio-group-active" : ""}`} style={{ opacity: (radioDiseaseType == 3) ? 0.5 : 1 }}>
                                        <input
                                          type="radio"
                                          name="testType"
                                          value={1}
                                          checked={radioTestType == 1}
                                          onChange={handleTestTypeChange}
                                          disabled = {radioDiseaseType == 3}
                                        />
                                        <span>Screening Test</span>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className={`radio-group ${radioTestType == 2 ? "radio-group-active" : ""}`} style={{ opacity: (radioDiseaseType == 3) ? 0.5 : 1 }}>
                                        <input
                                          type="radio"
                                          name="testType"
                                          value={2}
                                          checked={radioTestType == 2}
                                          onChange={handleTestTypeChange}
                                          disabled = {radioDiseaseType == 3}
                                        />
                                        <span>Confirmatory Test</span>
                                      </div>
                                    </div>
                                  </div>
                                  <button
                                    className="sickle-save-button"
                                    onClick={handleSave}
                                    disabled={!isNextStep}
                                  >
                                    {SickleNextLoading ? 'Loading...' : 'Next'}
                                  </button>
                                </>
                                :
                                <>
                                  <div className="col-md-12 text-center">
                                    You are not logged in with sickle cell program. Please login !
                                  </div>
                                </>
                              }
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
    </>
  );
};
